import type { V5AddressSummary } from '@/types/api'

/** "Keizersgracht 123, 1015 CJ Amsterdam", or the uuid when nothing else is known. */
export function addressLabel(a: V5AddressSummary): string {
  const line = [a.street, a.houseNumber, a.houseNumberAdd].filter(Boolean).join(' ')
  const city = [a.postalCode, a.city].filter(Boolean).join(' ')
  return [line, city].filter(Boolean).join(', ') || a.addressUuid
}
